import { Button, Popover, Select } from 'antd'

const beanIcon = require('@assets/images/arcbean3.png')
const disabledBeanIcon = require('@assets/images/arcbean3_disbaled.png')

const GenerateActionBar = ({
    showNumSelect,
    generateNum,
    labelRender,
    setGenerateNum,
    disabled,
    isLoading,
    loading,
    handleGenerate,
    costBean,
    bottomRef,
    styles,
    showMemberIcon,
    buttonText = '生成',
    hideCostBean = false,
}) => {
    const renderButtonContent = (disabledIcon = false) => (
        <div className={styles.GenerateBtn}>
            <span>{buttonText}</span>
            {!hideCostBean && (
                <>
                    <img src={disabledIcon ? disabledBeanIcon : beanIcon} />
                    <span>{costBean}</span>
                </>
            )}
            {showMemberIcon && <span className={styles.teamIcon} />}
        </div>
    )

    return (
        <div className={styles.FixedBottom} ref={bottomRef}>
            {showNumSelect &&
                <Select
                    value={generateNum}
                    options={[
                        { label: "1张", value: 1 },
                        { label: "2张", value: 2 },
                        { label: "3张", value: 3 },
                        { label: "4张", value: 4 },
                    ]}
                    labelRender={labelRender}
                    onChange={setGenerateNum}
                />}
            {(disabled || isLoading) ? (
                <Popover content="请完善上方信息" trigger="hover" placement="topRight">
                    <span className={styles.GenerateBtnPopoverTrigger}>
                        <Button
                            type="primary"
                            block
                            disabled={true}
                            loading={loading}
                            onClick={handleGenerate}
                        >
                            {renderButtonContent(true)}
                        </Button>
                    </span>
                </Popover>
            ) : (
                <Button
                    type="primary"
                    block
                    disabled={false}
                    loading={loading}
                    onClick={handleGenerate}
                >
                    {renderButtonContent(false)}
                </Button>
            )}
        </div>
    )
}

export default GenerateActionBar
